import React, { useEffect, useRef, useState } from 'react';
import './index.css';
import { widget } from '../../charting_library';
import datafeed from './api';
import { API_BASE_URL } from '../constants/apiConfiguration';
import Checkbox from './../Widgets/Checkbox';
import CyclesSelector from '../Widgets/CyclesSelector';
import { initPlanetIngresses } from '../Planets/planet-ingresses';
import { initUI } from '../Planets/planet-ingresses.ui.js';       // importa il controller che gestisce i transiti
import { initPlanetAspects } from '../Planets/planet-aspects.js';		  // importa il controller che gestisce gli aspetti
import { initAspectsUI } from '../Planets/planet-aspects.ui.js';




function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

var myTwWidget=null;
var cycles_selected=[];
var cycles_loaded = [];
var cycles_chart = [];  



function getCyclesLoaded(){
	const cycles_plotted=myTwWidget.chart().getAllStudies();
	let cycles=[];
	cycles_chart=[];
	cycles_plotted.forEach(element => {
		let simbolo = myTwWidget.chart().getStudyById(element.id)._study._legendView._header;
		simbolo=simbolo.replace("CP:","cb_").toLowerCase();
		cycles.push(simbolo);
		// costruisce anche l'oggetto cycles_chart
		cycles_chart.push({'id' : element.id, 'simbolo' : simbolo});
	});	
	return(cycles);
}

// finestra modale
const Modal = ({ handleClose, show, children }) => {
	const showHideClassName = "modal";//show ? "modal show" : "modal hide";

	//recupero lista cicli planetari
	if(myTwWidget){ // serve perchè all'avvio è null
		cycles_loaded=getCyclesLoaded();
	//console.log("elenco cicli: " + cycles_loaded);	
	}
	//recupero simbolo (ciclo planetario) partendo dall'id dello studio 
	//tvWidget.chart().getStudyById("1r8NEO")._study._inputs.symbol;

	function sendCiclesSelected (cicles) { // la callback da Cycles Selector che aggiorna la lista dei cicli selezionati
		//console.log("_Elenco cicli selezionati: " + cicles);
		cycles_selected=cicles;
	};
	
	if(handleClose){ // evento di chiusura della modale
		console.log("handle modal-close");
	}
	

	return (
		<div id="modalCicli" className="modal fade" aria-hidden="true" >
			<div className="modal-dialog mw-100 w-75">
				<div className="modal-content">
					<div className="modal-body">
						{children}
						<CyclesSelector cycles_selected={cycles_loaded} sendCiclesSelected={sendCiclesSelected} />
						<button onClick={handleClose}>Conferma</button>
					</div>
				</div>
			</div>
		</div>
	);
};

function isTestUser(){
	let ret = false;
	const currentUsr = sessionStorage.getItem('userLogged');
	if(currentUsr && (currentUsr=='jaymack@virgilio.it')) ret = true;
	return ret;
}

// --- INIZIO: metodi per gestione posizione zoom su grafico ---

/*

var needChartZoomReposition=false;
var position_form=0;
var position_to=0;
var currentChartSaved=null;

// metodo per caricare da locastorage e impostare l'ultima posizione di zoom salvata per il grafico corrente
function loadPositionCurrentChart () {
	// se esiste nel locastorage l'impostazione dello zoom salvata per questo studio la ripristina
	let chartZoomData=localStorage.getItem("chartZoomData");
	let chartSaved=getCurrentChartLoaded();
	if(chartZoomData){
		chartZoomData=JSON.parse(chartZoomData);
		if(chartZoomData){
			for(let i=0;i<chartZoomData.length;i++){
				if(chartZoomData[i].chart_name==chartSaved){
					if(chartZoomData[i].from && chartZoomData[i].to){
						needChartZoomReposition=false;
						myTwWidget.activeChart().setVisibleRange(
							{ from: chartZoomData[i].from, to: chartZoomData[i].to },
							{ percentRightMargin: 20 }
						).then(() => console.log('New visible range is applied of ' + chartSaved));
					}		
				}
			}	
		}
	}		
}

// metodo per salvare su locastorage l'ultima posizione di zoom del grafico corrente
function savePositionCurrentChart (from, to) {
	let chartZoomData=localStorage.getItem("chartZoomData");
	let chartSaved=getCurrentChartLoaded();
	if(chartZoomData==null){
		// primo salvataggio
		chartZoomData=[];
		let newData={"chart_name" : chartSaved, "from" : from, "to" : to};
		chartZoomData.push(newData);
		localStorage.setItem("chartZoomData", JSON.stringify(chartZoomData));
	} else {
		// aggiornamento salvataggio
		chartZoomData=JSON.parse(localStorage.getItem("chartZoomData"));
		let update=-1;
		for(let i=0;i<chartZoomData.length;i++){
			//console.log('chart_name: ' + chartZoomData[i].chart_name);
			//console.log('from: ' + chartZoomData[i].from);
			//console.log('to: ' + chartZoomData[i].to);
			if(chartZoomData[i].chart_name==chartSaved){
				// flag update
				update=i;
			}
		}
		if(update>-1){
			// update
			chartZoomData[update].from=from;
			chartZoomData[update].to=to;
			localStorage.setItem("chartZoomData", JSON.stringify(chartZoomData));	
		} else {
			// new insert
			let newData={"chart_name" : chartSaved, "from" : from, "to" : to};
			chartZoomData.push(newData);
			localStorage.setItem("chartZoomData", JSON.stringify(chartZoomData));	
		}
		
	}
}

// restituisce il nome del grafico caricato 
function getCurrentChartLoaded(){
	const currentStudy=$('#tv_chart_container > iframe').contents().find("div")[277].childNodes[0].data;
	//console.log('Study ' + currentStudy + ' has loaded!');
	return(currentStudy);
}

function attachSaveChartEvent(){
	// agganciare evento al click in un div
	const d=$('#tv_chart_container > iframe').contents().find("div");

	$(d[276]).click(function() {
		savePositionCurrentChart(position_form, position_to);
		console.log("[276] chart position has saved !"); //alert( "chart position has saved 276!" );
	});
	$(d[277]).click(function() {
		savePositionCurrentChart(position_form, position_to);
		console.log("[277] chart position has saved !"); //alert( "chart position has saved 277!" );
	});
	$(d[278]).click(function() {
		savePositionCurrentChart(position_form, position_to);
		console.log("[278] chart position has saved !"); //alert( "chart position has saved 278!" );
	});
}
*/
// --- FINE: metodi per salvataggio posizione zoom su grafico ---


export const TVChartContainer =() => {

	const chartContainerRef = useRef();

	const defaultProps = {
		symbol: '',
		interval: '1D',
		datafeedUrl: datafeed, //'https://demo_feed.tradingview.com', // 'http://localhost:5000'
		libraryPath: '/charting_library/',
		chartsStorageUrl: API_BASE_URL + 'LoadSaveCharts', // 'https://saveload.tradingview.com',
		chartsStorageApiVersion: '1.1',
		snapshot_url: API_BASE_URL + 'snapshot',
		clientId: 'giantrader',
		userId: sessionStorage.getItem('userLogged'), // this.props.userId,
		fullscreen: false,
		autosize: true,
		studiesOverrides: {
		},
		overrides: {
			// Mostra la scala sinistra
          	'scalesProperties.showLeftScale': true,
          	// Facoltativo: rendi la griglia globale leggermente visibile
          	'paneProperties.horzGridProperties.style': 0,
          	'paneProperties.horzGridProperties.color': 'rgba(255,255,255,0.08)',
		},
		locale: "it"
	};

	// carica/elimina i cicli selezionati nella modale
	function loadCicli() {
		console.log(".....loadCicli!!");
		//console.log("elenco cicli selezionati: " + cycles_selected);
		
		//recupera i cicli già presenti nel grafico
		cycles_loaded=getCyclesLoaded();

		if(cycles_loaded.length || cycles_selected.length){
			// trova l'id del primo studio inserito nel secondo asse Y
			let studies=myTwWidget.chart().getAllStudies();
			let idStudyRif=null;
			if(studies.length>0){
				if(studies[0].name!="Volume"){
					idStudyRif=studies[0].id;
				}
			}		

			// controlla se ci sono cicli da eliminare
			cycles_loaded.forEach(element => {
				if(!cycles_selected.includes(element)){
					console.log('<<<< --- rimozione ciclo:  ' + element);
					const el=cycles_chart.find(item=>item.simbolo==element);
					myTwWidget.chart().removeEntity(el.id);
				};				 
			});

			// controlla se ci sono nuovi cicli da inserire
			cycles_selected.forEach(element => {
				if(!cycles_loaded.includes(element)){
					element=element.replace("cb_","").toLowerCase();
					console.log('<<<< --- inserisco ciclo:  ' + element);
					myTwWidget.chart().createStudy('Compare', false, false, ["close", 'CP:' + element]).then(id => {
						if (id) {
							if(idStudyRif!=null){
								console.log("id studio rif. : " + idStudyRif);
								myTwWidget.chart().getStudyById(id).changePriceScale(idStudyRif);
							} else {
								myTwWidget.chart().getStudyById(id).changePriceScale('new-left');
								idStudyRif=id;	
							}
							console.log("Inserito studio con id: " + id);
							// imposta la scala dei due assi Y come normal
							myTwWidget.activeChart().getPanes()[0].getLeftPriceScales()[0].setMode(0);
							myTwWidget.activeChart().getPanes()[0].getRightPriceScales()[0].setMode(0);
						}
					});				
				}
			});
			
		}

	};



	// -- INIZIO: usate dalla modale --
	const [show, setShow] = useState(false);

	function showModal() {
		//setShow(true);
		$("#modalCicli").modal("show");
	};

	function hideModal() {
		$("#modalCicli").modal("hide");
		//setShow(false);
		loadCicli();
	};

	// -- FINE: usate dalla modale --


	// -- INIZIO: gestione checkboxes interni alla modale dei cicli --

		
	function handleFormSubmit(formSubmitEvent, useThis) {
	//handleFormSubmit = (formSubmitEvent, useThis) => {
		formSubmitEvent.preventDefault();

		//console.log("deb..." + customData.useThis);
		console.log("deb 2: " + myTwWidget);
		//myTwWidget.chart().createStudy('Compare', false, false, ["close", 'CP:Giove-Nettuno']);
	}
		
	// -- FINE: gestione checkboxes interni alla modale dei cicli --



	function removeEntity(chart, id) {
		if (id) chart.removeEntity(id);
	}


	// Trova lo study per "description" e ritorna il suo entityId (o null)
	function findStudyIdByDescription(chart, description) {
	const studies = chart.getAllStudies(); // array di entità
	for (const s of studies) {
		// s.name è in genere la short/description visualizzata
		// molte build espongono anche s.description; usa quello che esiste nella tua
		if (s && (s.description === description || s.name === description)) {
			return s.id; // entity id
		}
	}
		return null;
	}

	// Assicura che esista al massimo uno "ConstLevels"
	// Se già presente, lo rimuove prima di crearne uno nuovo
	function ensureSingletonConstLevels(chart) {
		const existingId = findStudyIdByDescription(chart, 'ConstLevels');
		if (existingId) chart.removeEntity(existingId);
	}
	
	function checkYSecondary(chart){
		// Prendi il primo pane (quello principale)
		const panes = chart.getPanes();            // -> IPaneApi[]
		const mainPane = panes[0];                 // supponendo 1 solo pane

		// Ottieni le price scale del lato destro
		const rightScales = mainPane.getRightPriceScales(); // -> IPriceScaleApi[]
		const leftScales  = mainPane.getLeftPriceScales();  // IPriceScaleApi[]
		
		// Scegli una scala "secondaria": quella che NON contiene la main series
		// (in genere la main series occupa la scala principale; le altre sono per overlay/indicatori)
		let secondaryScale = rightScales.find(s => !s.hasMainSeries());

		// Se non la trovi, puoi usare la sinistra o la prima right disponibile come fallback
		if (!secondaryScale) {
			const leftScales = mainPane.getLeftPriceScales();
			secondaryScale = leftScales.find(s => !s.hasMainSeries()) || rightScales[0] || leftScales[0];
		}

		// Ora puoi fissare il range 0–180 su questa scala senza crearne una nuova
		secondaryScale.setAutoScale(false);
		secondaryScale.setVisiblePriceRange({ from: 0, to: 180 });
		
		return secondaryScale;
	}


	let rifSecY=null;
	// Crea "ConstLevels" su new-left (inputs come OBJECT) e ritorna l'entityId
	async function createConstLevels(chart, l1 = 30, l2 = 45, l3 = 60, l4 = 90, l5 = 120, l6 = 135, l7 = 150) {
		const panes = chart.getPanes();
		const mainPane = panes[0];
		let leftScales  = mainPane.getLeftPriceScales();
		const target = leftScales[0];

		rifSecY = checkYSecondary(chart);
		//rifSecY = debugSecPriceScale(chart);
		// Prima di creare, evitiamo duplicati
		ensureSingletonConstLevels(chart);

		const idOrPromise = chart.createStudy(
			'ConstLevels',          // deve matchare metainfo.description
			true,                   // forceOverlay: main pane
			false,                  // lock
			{ level_1: l1, level_2: l2, level_3: l3, level_4: l4, level_5: l5, level_6: l6, level_7: l7  }, // inputs OBJECT (non array!)
			null,                   // overrides
			//{ priceScale: target }
			//{ priceScale: 'new-left' } // pin su nuova scala sinistra
			//{ priceScaleId: rifSecY } // pin su nuova scala sinistra

		);
		
        // Attendi l'entityId anche se la build restituisce una Promise/thenable
        const id = await Promise.resolve(idOrPromise);

		
		// 2) Ottieni l’oggetto studio
		const study = chart.getStudyById(id); // IStudyApi


		// 3) Trova la "Z" (scala di sinistra secondaria) e prendi un hostStudyId
		const pane = chart.getPanes()[0];                           // IPaneApi
		leftScales = pane.getLeftPriceScales();                // IPriceScaleApi[]
		// preferisci una scala sinistra senza main series (secondaria)
		const scaleZ = leftScales.find(s => !s.hasMainSeries()) || leftScales[0];
		const hostIds = (scaleZ && scaleZ.getStudies) ? scaleZ.getStudies() : [];

		if (hostIds.length > 0) {
			// 4) Fissa lo studio alla stessa scala dell’host
			study.changePriceScale(hostIds[0]);                        // equivalente del “Fissa all’asse Z”
			// (opzionale) imposta range fisso sulla Z
			scaleZ.setAutoScale(false);
			scaleZ.setVisiblePriceRange({ from: 0, to: 180 });
		} else {
			console.warn('Nessuno studio è attualmente agganciato alla scala Z (sinistra).');

			// Fallback possibili (vedi sezione sotto):
			// a) usa changePriceScale('new-left') per creare una scala sinistra nuova e agganciare lì
			// b) pinna programmaticamente un “host” a Z e poi richiama changePriceScale(hostEntityId)
			study.changePriceScale('new-left');
		}


		
		// 5) si assicura che i label indicatori siano ON (se l’utente li aveva spenti)
		chart.applyOverrides({
			"scalesProperties.showStudyLastValue":  true,  // mostra sempre l'etichetta sull'asse con il valore dei livelli 
			"scalesProperties.showStudyPlotLabels": false  // non mostrare l'etichetta con il nome dei livelli
		});

		return id;
	}


	function debugSecPriceScale(chart){

		const panes = chart.getPanes();
		const mainPane = panes[0];
		const rightScales = mainPane.getRightPriceScales();
		const leftScales  = mainPane.getLeftPriceScales();

		console.log('Right scales:', rightScales.map(s => ({ hasMain: s.hasMainSeries(), range: s.priceScale().getVisiblePriceRange() })));
		console.log('Left scales:',  leftScales.map(s  => ({ hasMain: s.hasMainSeries(), range: s.priceScale().getVisiblePriceRange() })));

		// Vedi su quale scala è finito:
		//const study = chart.getStudyById(id);
		//console.log('Study pinned? check via targetScale.getStudies():', getExistingSecondaryScale(chart).getStudies());
		return leftScales[0];
	}

	// Toggle con fallback: se hai un id, prova a rimuovere; se non ce l'hai o è cambiato,
	// cerca per description e rimuovi quello che trova.
	async function toggleConstLevels(chart, ref) {
		// ref è un oggetto { id: <number|null> } così puoi mutarlo (chiusura)
		/*
		if (ref.id) {
			chart.removeEntity(ref.id);
			ref.id = null;
			return;
		}
		*/
		// se non avevi l'id (o era stale), prova a trovarlo
		const existingId = findStudyIdByDescription(chart, 'ConstLevels');
		if (existingId) {
			chart.removeEntity(existingId);
			ref.id = null;
		} else {
			// non esiste: crealo
			ref.id = await createConstLevels(chart);
			/*
			ref.id.then((val) => { 
				console.log("asynchronous logging has val:", val)
			});
			*/
		}


		const panes = chart.getPanes();
		const mainPane = panes[0];
		const leftScales  = mainPane.getLeftPriceScales();
		const rightScales = mainPane.getRightPriceScales();
		const target = leftScales[0];
		const target1 = rightScales[0];

		//console.log('Studi agganciati alla Z (left[0]):', target.getStudies()); // deve includere l’entityId appena creato
		//console.log('Studi agganciati alla Y-Right (right[0]):', target1.getStudies()); 

	}


	// 1) riferimento mutabile al tuo indicatore (chiuso nel closure dell'handler)
	const constLevelsRef = { id: null };


	useEffect(() => {
		
		const widgetOptions = {
			symbol: defaultProps.symbol,
			// BEWARE: no trailing slash is expected in feed URLdb	
			datafeed: datafeed,
			interval: defaultProps.interval,
			container: chartContainerRef.current,
			library_path: defaultProps.libraryPath,
			locale: getLanguageFromURL() || defaultProps.locale,
			disabled_features: [/*'use_localstorage_for_settings'*/],
			enabled_features: ['study_templates'],
			charts_storage_url: defaultProps.chartsStorageUrl,
			charts_storage_api_version: defaultProps.chartsStorageApiVersion,
			client_id: defaultProps.clientId,
			user_id: defaultProps.userId,
			fullscreen: defaultProps.fullscreen,
			autosize: defaultProps.autosize,
			studies_overrides: defaultProps.studiesOverrides,
			determine_first_data_request_size_using_visible_range: false,
			debug: false,
			load_last_chart: true,
			display_market_status: false,
			fix_left_edge: false,
			/*
			time_scale: {
				min_bar_spacing: 10,
			}
			*/
			

			// 👉 Custom indicator: tre linee costanti (90/120/150)
			custom_indicators_getter: function (PineJS) {
				return Promise.resolve([
				{
					name: 'ConstLevels',
					metainfo: {
					_metainfoVersion: 51,
					id: 'ConstLevels@tv-basicstudies-1',
					description: 'ConstLevels',
					shortDescription: 'ConstLevels',
					is_price_study: true,          // vive nel main pane (come un "price study")
					isCustomIndicator: true,
					format: { type: 'price', precision: 0 },
					// tre plot di tipo linea
					plots: [
						{ id: 'plot_0', type: 'line' },
						{ id: 'plot_1', type: 'line' },
						{ id: 'plot_2', type: 'line' },						
						{ id: 'plot_3', type: 'line' },						
						{ id: 'plot_4', type: 'line' },						
						{ id: 'plot_5', type: 'line' },						
						{ id: 'plot_6', type: 'line' },						
						{ id: 'plot_min', type: 'line' },  // 0
						{ id: 'plot_max', type: 'line' },  // 180s
					],
					defaults: {
						styles: {
							plot_0: {
								linestyle: 0, linewidth: 2, plottype: 2,
								color: '#1f77b4', trackPrice: true, transparency: 0,
							},
							plot_1: {
								linestyle: 0, linewidth: 2, plottype: 2,
								color: '#ff7f0e', trackPrice: true, transparency: 0,
							},
							plot_2: {
								linestyle: 0, linewidth: 2, plottype: 2,
								color: '#2ca02c', trackPrice: true, transparency: 0,
							},

							plot_3: { linestyle: 0, linewidth: 2, plottype: 2, color: '#d62728', trackPrice: true, transparency: 0 },
							plot_4: { linestyle: 0, linewidth: 2, plottype: 2, color: '#9467bd', trackPrice: true, transparency: 0 },
							plot_5: { linestyle: 0, linewidth: 2, plottype: 2, color: '#8c564b', trackPrice: true, transparency: 0 },
							plot_6: { linestyle: 0, linewidth: 2, plottype: 2, color: '#8c764b', trackPrice: true, transparency: 0 },
												
							// ancoraggi: **visibili** ma trasparenti ⇒ contano nell’autoscale, non “sporcano” il grafico
							plot_min: { linestyle: 0, linewidth: 2, plottype: 2, color: '#000000', trackPrice: true, transparency: 0, visible: true },
							plot_max: { linestyle: 0, linewidth: 2, plottype: 2, color: '#000000', trackPrice: true, transparency: 0, visible: true },
						},

						inputs: {
							level_1: 30,
							level_2: 45,
							level_3: 60,
							level_4: 90,
							level_5: 120,
							level_6: 135,
							level_7: 150,
							min: 0,          // default del range
							max: 180,     	 // default del range		
						},
					},
					styles: {
						plot_0: { title: 'L1(30)' },
						plot_1: { title: 'L2(45)' },
						plot_2: { title: 'L3(60)' },
						plot_3: { title: 'L4(90)' },   // NEW
						plot_4: { title: 'L5(120)' },  // NEW
						plot_5: { title: 'L6(150)' },  // NEW
						plot_6: { title: 'L7(150)' },  // NEW
						plot_min: { title: 'min(0)' },
						plot_max: { title: 'max(180)' },
					},
					// tre input numerici (li puoi cambiare alla creazione)
					inputs: [
						{ id: 'level_1', name: 'Level 1', type: 'float', defval: 30,  min: -1e9, max: 1e9 },
						{ id: 'level_2', name: 'Level 2', type: 'float', defval: 45,  min: -1e9, max: 1e9 },
						{ id: 'level_3', name: 'Level 3', type: 'float', defval: 60,  min: -1e9, max: 1e9 },
						{ id: 'level_4', name: 'Level 4', type: 'float', defval: 90,  min: -1e9, max: 1e9 },   // NEW
						{ id: 'level_5', name: 'Level 5', type: 'float', defval: 120, min: -1e9, max: 1e9 },   // NEW
						{ id: 'level_6', name: 'Level 6', type: 'float', defval: 135, min: -1e9, max: 1e9 },   // NEW
						{ id: 'level_7', name: 'Level 7', type: 'float', defval: 150, min: -1e9, max: 1e9 },   // NEW
						{ id: 'min', name: 'Min', type: 'float', defval: 0 },
						{ id: 'max', name: 'Max', type: 'float', defval: 180 },
					],
					},

					// constructor: ritorna tre serie costanti = (level_1, level_2, level_3)

					constructor: function () {
					this.init = function (ctx, inputCallback) {
						this._ctx = ctx;
						this._input = inputCallback;
						const symbol = PineJS.Std.ticker(this._ctx);
						this._ctx.new_sym(symbol, PineJS.Std.period(this._ctx));
					};

					this.main = function (ctx, inputCallback) {
						this._ctx = ctx;
						this._input = inputCallback;

						// 1) seleziona il main symbol e crea il "time" come variabile
						this._ctx.select_sym(0);
						const mainTime = this._ctx.new_var(this._ctx.symbol.time);

						// 2) leggi gli input (object → level_1/2/3)

						// 6 input
						const l1 = this._input(0);
						const l2 = this._input(1);
						const l3 = this._input(2);
						const l4 = this._input(3); // NEW
						const l5 = this._input(4); // NEW
						const l6 = this._input(5); // NEW
						const l7 = this._input(6); // NEW

						// min/max (dagli input successivi)
						const min = this._input(6);
						const max = this._input(7);


						// 3) crea variabili costanti e ADOTTA il time del main symbol
						const v1 = this._ctx.new_var(l1).adopt(mainTime, mainTime, 1);
						const v2 = this._ctx.new_var(l2).adopt(mainTime, mainTime, 1);
						const v3 = this._ctx.new_var(l3).adopt(mainTime, mainTime, 1);
						const v4 = this._ctx.new_var(l4).adopt(mainTime, mainTime, 1); // NEW
						const v5 = this._ctx.new_var(l5).adopt(mainTime, mainTime, 1); // NEW
						const v6 = this._ctx.new_var(l6).adopt(mainTime, mainTime, 1); // NEW
						const v7 = this._ctx.new_var(l7).adopt(mainTime, mainTime, 1); // NEW

						// NEW: serie per plot_min / plot_max
						const vMin = this._ctx.new_var(min).adopt(mainTime, mainTime, 1);
						const vMax = this._ctx.new_var(max).adopt(mainTime, mainTime, 1);


						// 4) ritorna tre "serie" allineate: ora la CL ha punti per ogni bar
  						return [v1, v2, v3, v4, v5, v6, v7, vMin, vMax];
					};
					},
				},
				]);
			},

		};

		



		const tvWidget = new widget(widgetOptions); 
		
		myTwWidget = tvWidget;
		
		
		myTwWidget.onChartReady(async () => {

			const chart = tvWidget.activeChart(); 
			myTwWidget.headerReady().then(async () => {
				const button = myTwWidget.createButton();
				button.setAttribute('title', 'Clicca per aggiungere i cicli planetari');
				button.classList.add('apply-common-tooltip');
				/*
							button.addEventListener('click', () => tvWidget.activeChart().executeActionById("symbolSearch"));
							button.setAttribute('id', 'custom_search');
				*/
				button.addEventListener('click', () => {
					showModal();
					//loadPositionCurrentChart();
				});
	
				button.textContent = 'Cicli';

				//var buttonSave=$('#tv_chart_container > iframe').contents().find("div")[277].childNodes[0].data;
				const btnGrid = myTwWidget.createButton();
				btnGrid.setAttribute('title', 'Livelli on/off');
				btnGrid.classList.add('appliy-common-tooltip');
				btnGrid.textContent = 'Livelli';
				btnGrid.addEventListener('click', async () => {
					await toggleConstLevels(chart, constLevelsRef);
				});

				// bottone ingressi ..
				// Prepara il controller (non ancora attivo)
				const ingressCtrl = await initPlanetIngresses(myTwWidget, {
					csvUrl: '/assets/effemeridi.csv',
					enabledPlanets: [],    // nessun pianeta selezionato per default
					displayMode: 'line'   // esplicito
				});



				// Recupera OHLC dal datafeed
				let myOhlc = [];
				try {
					const data = await chart.exportData({ includeTime: true });
					myOhlc = data.data.map(d => ({
					time: Math.floor(new Date(d.time).getTime() / 1000),
					open: Number(d.open),
					high: Number(d.high),
					low: Number(d.low),
					close: Number(d.close)
					}));
				} catch (e) {
					console.warn('exportData non disponibile, provo getSeries()');
					const series = chart.getSeries();
					const bars = series.getBars ? series.getBars() : [];
					myOhlc = bars.map(b => ({
					time: (b.time > 1e12) ? Math.floor(b.time / 1000) : b.time,
					open: b.open,
					high: b.high,
					low: b.low,
					close: b.close
					}));
				}


				// bottone aspetti
				// prepara il controller 			
				const aspectsCtrl = await initPlanetAspects(myTwWidget, {
					csvUrl: '/assets/effemeridi.csv',
					selectedPairs: [],
					selectedAspects: [],
					orbDeg: 3,
					retroPlanets: [],
					lc: myOhlc     // <<< injection
				});
				
				/*
				const btn = myTwWidget.createButton();                 // HTMLElement
				btn.textContent = 'Ingressi';                      // titolo
				btn.setAttribute('title', 'Mostra/Nascondi ingressi planetari'); // tooltip

				// helper per stato visuale (facoltativo)
				const setActiveStyle = (on) => {
					btn.style.fontWeight = on ? '700' : '400';
					btn.style.opacity = on ? '1' : '0.75';
				};

				// Click = toggle
				btn.addEventListener('click', async () => {
					await ingressCtrl.toggle();
					setActiveStyle(ingressCtrl.isActive());
				});

				// stato iniziale: spento
				setActiveStyle(false);
				*/
				
				// --- START: selettore pianeti per ingressi
				// init ui controllo transiti ...
				const ui = initUI(myTwWidget, ingressCtrl, {
					planets: [], // nessun pianeta selezionato per default   //['SOLE','LUNA','MERCURIO','VENERE','MARTE','GIOVE','SATURNO','URANO','NETTUNO'],
					showStrictClear: true,                       // mostra il tasto “Strict clear”
					ingressButtonTitle: '',
					planetsButtonTitle: 'Ingressi'
				});

				if(isTestUser()){
					// init ui controllo aspetti ...										
					const aspectsUI = initAspectsUI(myTwWidget, aspectsCtrl, {
						aspectsButtonTitle: 'Aspetti',
						defaultPairs: [],
						defaultAspects: [],
						defaultOrb: 3,
						defaultRetroPlanets: []
					});					
				}
				// Quando smonti la pagina/grafico:
				// ui.dispose();


				// --- END: selettore pianeti per ingressi

			});			
			

			//drawSecondGrid(tvWidget);
			//await testDrawLeftGrid(tvWidget.chart());
			
			// Esegui solo quando la storia dati è pronta (dopo studi/serie di default)
			chart.dataReady(async () => {
				//await testDrawSimple(tvWidget.chart());			
			});
			

			/*
			let timer;
			const runLast = () => {
				clearTimeout(timer);
				// aspetta un attimo (es. 150–300ms) dopo l’ultimo evento di data/study
				timer = setTimeout(async () => {
					//await testDrawSimple(chart);
					//await testDrawLeftGrid(chart);
					//await addSecondaryScaleWithStudy(chart);
					//await drawSecondGrid(chart);
				}, 250);
			};

			const sub = chart.onDataLoaded(); // Subscription
			
			sub.subscribe(runLast);

			chart.dataReady(runLast);
			chart.onDataLoaded().subscribe(runLast);
			*/

			
			// Se cambi simbolo/risoluzione/pane, invalida il riferimento (id diventa stale)
			chart.onSymbolChanged().subscribe(() => { constLevelsRef.id = null; });
			chart.onIntervalChanged().subscribe(() => { constLevelsRef.id = null; });

		});

		return () => {
			tvWidget.remove();
		};
	});

	return (
		<main>
			<Modal show={show} handleClose={hideModal}>
			</Modal>
			<div
				ref={chartContainerRef}
				className={'TVChartContainer'}
			/>
		</main>
	);


	/*
	return (
		<div
			ref={chartContainerRef}
			className={'TVChartContainer'}
		/>
	);
	*/


}
